<template>
    <el-dialog title="" :visible.sync="show" :modal="true" :close-on-click-modal="false" class="commonDialog tagDialog"
        :append-to-body="true" ref="deleteDialog" @close="cancelDialog" @open="dialogOpen">
        <div slot="title">
            <i class="el-icon-warning"></i><span class="title">{{dialogTitle}}</span>
        </div>
        <div class="content tagEdit">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-width="labelWidth" class="demo-ruleForm">
                <template v-if="type==='readable' || type==='editable'">
                    <el-form-item label="模板名称">
                        <div>{{title}}</div>
                    </el-form-item>
                </template>
                <template v-else>
                    <!-- <el-form-item label="类型" class="is-required">-->
                    <!-- <div>{{certiType}}</div> -->
                    <!-- <el-radio v-model="ocrType" :label="1">英文OCR</el-radio>
            <el-radio v-model="ocrType" :label="2">中英文OCR</el-radio>
          </el-form-item> -->
                    <!-- 预置模板复制 -->
                    <template v-if="type === 'copy-defaultTmp'">
                        <el-form-item label="单证类型" class="is-required">
                            <div>{{newType}}</div>
                        </el-form-item>
                    </template>
                    <!-- 自定义模板复制 -->
                    <template v-if="type === 'copy-diyTmp'">
                        <el-form-item label="单证类型" class="is-required">
                            <div>{{rowItem.name}}</div>
                        </el-form-item>
                    </template>
                    <el-form-item label="新模板名称" prop="name" style="margin-bottom: 20px;">
                        <el-input v-model="ruleForm.name" style="width:300px;"></el-input>
                    </el-form-item>
                </template>
                <el-form-item label="标签" prop="tag" :class="['selectMul']">
                    <template v-if="type==='readable'">
                        <div :class="{tags:type==='readable'}">
                            <ul class="tagList">
                                <li v-for="(item,index) in defaultSeleted" :key="index">
                                    <span>{{item}}</span>
                                </li>
                            </ul>
                        </div>
                    </template>
                    <template v-else>
                        <div>
                            <el-select v-model="defaultSeleted" multiple filterable allow-create default-first-option
                                placeholder="请填写标签，多个标签按【回车键】区分" @change="tagChange" ref="selectkeywords"
                                popper-class="selectCreateMul" class="editTagSelect">
                                <el-option v-for="item in options" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </template>
                </el-form-item>
            </el-form>
            <div class="footer">
                <el-button type="primary" class="cancel"
                    v-if="type==='editable' || type==='copy-defaultTmp' || type==='copy-diyTmp'"
                    @click="cancelDialog">取消</el-button>
                <el-button type="primary" class="confirm" @click="confirmDialog('ruleForm')">确定</el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script>
    import _ from 'lodash'

    export default {
        name: 'deleteDialog',
        data() {
            return {
                show: false,
                options: [],
                defaultSeleted: [],
                newType: '',
                newTypeOptions: [],
                ruleForm: {
                    name: ''
                },
                rules: {
                    name: [
                        { required: true, message: '请输入新模板名称', trigger: 'blur' }
                    ],
                    newType: [
                        { required: true, message: '请输入新模板类型', trigger: 'blur' }
                    ]
                },
                labelWidth: '',
                count: 0,
                ocrType: ''
            }
        },
        computed: {
            dialogTitle() {
                if (this.type === 'readable') {
                    return '更多标签'
                } else if (this.type === 'editable') {
                    return '编辑标签'
                } else {
                    return '复制模板'
                }
            }
        },
        components: {},
        watch: {
            dialogTitle: {
                deep: true,
                handler: function (newVal) {
                    if (newVal === '更多标签') {
                        this.labelWidth = '70px'
                    } else if (newVal === '编辑标签') {
                        this.labelWidth = '70px'
                    } else {
                        this.labelWidth = '96px'
                    }
                }
            }
        },
        mounted() {
            this.options = this.defaultOption
            this.defaultSeleted = this.defaultOption.map(item => {
                return item.label
            })

            this.ruleForm.name = this.title
            this.setNewType()
        },
        destoryed() {
            this.defaultSeleted.splice(0)
        },
        methods: {
            cancelDialog() {
                this.defaultSeleted.splice(0)
                this.show = false

                this.cancel.call(this)
            },
            confirmDialog(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.confirm.call(
                            this,
                            {
                                name: this.ruleForm.name,
                                tag: this.defaultSeleted.toString(),
                                type: this.newType,
                                certiType: this.ocrType
                            },
                            this.count
                        )

                        this.defaultSeleted.splice(0)

                        this.show = false
                    } else {
                        //console.log('error submit!!')
                        return false
                    }
                })
            },
            setNewType() {
                let category = this.rowItem.category
                //console.log(this.rowItem, 'rowItem')
                this.ocrType = this.rowItem.certiType
                if (category === 1) {
                    this.newTypeOptions = [
                        {
                            value: category,
                            label: this.$utils.certiType[category]
                        }
                    ]
                }
                if (
                    category === 31 ||
                    category === 32 ||
                    category === 33 ||
                    category === 34 ||
                    category === 38 ||
                    category === 39 ||
                    category === 43 ||
                    category === 13 ||
                    category === 14 ||
                    category === 15 ||
                    category === 16
                ) {
                    this.newTypeOptions = [
                        {
                            value: category,
                            label: this.$utils.certiType[category]
                        }
                    ]
                }
                if (category === 11 || category === 12) {
                    this.newTypeOptions = [
                        {
                            value: 11,
                            label: this.$utils.certiType[11]
                        },
                        {
                            value: 12,
                            label: this.$utils.certiType[12]
                        }
                    ]
                }
                if (category === 35 || category === 41 || category === 44) {
                    this.newTypeOptions = [
                        {
                            value: 35,
                            label: this.$utils.certiType[35]
                        },
                        {
                            value: 41,
                            label: this.$utils.certiType[41]
                        },
                        {
                            value: 44,
                            label: this.$utils.certiType[44]
                        }
                    ]
                }
                this.newType = this.$utils.certiType[category]
            },
            clearSeleced() {
                this.count++
                this.defaultSeleted.splice(0)
            },
            tagChange(x) {
                if (x.length === 0) {
                    return
                }
                this.count++
                this.defaultSeleted = _.uniq(x)

                if (x.length != this.defaultSeleted.length) {
                    this.$message.error('输入了重复值')
                }
                if (x.length > 10) {
                    this.$message.info('每个模板支持最多添加10个标签')
                    this.defaultSeleted.pop()
                }
                if (x[x.length - 1].length > 20) {
                    this.$message.info('每个标签最多20个字')
                    this.defaultSeleted.pop()
                }
            },
            dialogOpen() {
                if (this.type !== 'readable') {
                    this.$nextTick(() => {
                        this.$refs.selectkeywords.toggleMenu = () => { }
                        //select allow-create组件输入重复的值，会把两个一样的值删除掉，避免删除所以把源代码中的方法置为空
                        this.$refs.selectkeywords.getValueIndex = () => { }
                        //blur自动补充值
                        this.$refs.selectkeywords.$refs.input.onblur = e => {
                            //点击输入框内部，区别于blur输入框外部
                            let value = e.target.value

                            if (value !== '') {
                                let result = this.defaultSeleted.find(val => {
                                    return val === value
                                })
                                if (result) {
                                    this.$message.error('输入了重复值')
                                }
                            }
                        }
                        //点击清除方法
                        let keyword = this.$refs['selectkeywords'].$el.querySelector(
                            '.el-input__suffix-inner'
                        )
                        keyword.onclick = () => {
                            this.clearSeleced()
                        }
                    })
                }
            },
            changeType() {
                this.ruleForm.name =
                    this.$utils.certiType[this.newType] + '_' + Date.now()
            }
        }
    }
</script>
<style>
    .tagDialog {
        .el-dialog {
            width: 560px;
            margin-top: -223px !important;
        }

        .el-dialog__body {
            padding: 20px 20px 26px 70px;
        }
    }

    .tagEdit {
        .el-form-item {
            margin-bottom: 6px;
        }

        .el-form-item__error {
            padding-left: 91px;
        }

        .top {
            display: flex;
            align-items: baseline;

            .key {
                width: 72px;
            }

            .el-select {
                width: 220px;
            }
        }

        .editTagSelect {
            width: 300px;

            .el-tag.el-tag--info {
                background-color: #f1f8ff;
                color: #9aa6c0;
                border: 0;
                height: 22px;
            }

            .el-select__tags-text {
                color: #9aa6c0;
            }

            .el-tag__close.el-icon-close {
                color: #fff;
                background-color: #8499c4;
            }
        }

        ul {
            li {
                float: left;
                line-height: 22px;
                height: 22px;
                overflow: hidden;
                margin-right: 10px;
                margin-bottom: 10px;

                span {
                    background-color: #f1f8ff;
                    color: #9aa6c0;
                    height: 22px;
                    padding: 0 10px;
                    line-height: 22px;
                    font-size: 13px;
                    /*border: 1px solid #e9e9eb;*/
                    /*border-radius: 4px;*/
                    box-sizing: border-box;
                    white-space: nowrap;
                    display: inline-block;
                }
            }
        }

        .tags {
            margin-top: 10px;

            .tagList {}
        }

        .info {
            line-height: 20px;
            color: #d2d2d2;
            font-size: 13px;
        }
    }
</style>